<!-- 表格内容为空的显示内容 -->
<template>
	<div>
		<!-- 表格两边的白色遮罩。避免表格内容左右滑动的时候，显示看着不舒服 -->
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: calc(100vh - 65px);width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: calc(100vh - 65px);width: 30px;"></div>
		
		<div v-show="tableShowData.length == 0" style="text-align: center;text-align:center;padding: 80px 0 50px;"
		:style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
			
		</div>
	</div>
	
</template>

<script>
export default {
    name: 'tableNull',
    props: ['tableShowData','table_null_width'],
    data(){
		return {
		}
    },
    methods: {
    }
}
</script>

<style scoped>
	
</style>